module.exports = __webpack_public_path__ + "static/img/preview_charts.c2839ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v7/preview_charts.png
// module id = cGD1
// module chunks = 0